import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as lmExpressActions from 'action/lmexpress'
import * as reportActions from 'action/report'
import ContentHeader from 'component/utils/ContentHeader'
import LmExpress from 'component/report/lmexpress/PreviousDayLmExpress'
import LmExpressHeader from 'component/report/lmexpress/LmExpressHeader'
import BranchFilterLmExpress from 'component/report/lmexpress/BranchFilterLmExpress'
import FeedbackError from 'component/utils/FeedbackError'

class PreviousDayLmExpressContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    fetchLmExpress: PropTypes.func.isRequired,
    fetchReports: PropTypes.func.isRequired,
    error: PropTypes.object,
    lmExpress: PropTypes.object,
    filters: PropTypes.object,
    auth: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    const {
      auth: { user },
    } = this.props

    let filtersVisible = false
    let lmExpressInfoVisible = true
    /* istanbul ignore else */
    if (user.locationCode === '999') {
      filtersVisible = true
      lmExpressInfoVisible = false
    }

    this.state = {
      filtersVisible,
      lmExpressInfoVisible,
      controlView: false,
    }

    this.getCsv = this.getCsv.bind(this)
  }

  componentWillMount() {
    const { fetchLmExpress, auth } = this.props

    /* istanbul ignore else */
    if (auth.user.locationCode !== '999') {
      fetchLmExpress(auth)
    }
  }

  getCsv() {
    const {
      fetchReports,
      filters,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 5,
    }

    fetchReports(user.dsToken, values, filters)
  }

  handleFetchLmExpress = (values) => {
    const { fetchLmExpress, auth } = this.props

    this.setState({ controlView: true })

    fetchLmExpress(auth, values)
  }

  componentWillReceiveProps() {
    const { filtersVisible, controlView } = this.state
    const {
      lmExpress,
      auth: { user },
    } = this.props
    /* istanbul ignore else */
    if (
      filtersVisible &&
      lmExpress &&
      controlView &&
      user.locationCode === '999'
    ) {
      this.invertStates()
    }
  }

  invertStates() {
    let { filtersVisible, lmExpressInfoVisible } = this.state

    filtersVisible = !filtersVisible
    lmExpressInfoVisible = !lmExpressInfoVisible

    this.setState({ filtersVisible })
    this.setState({ lmExpressInfoVisible })
  }

  renderError(message) {
    /* istanbul ignore else */
    if (message.dsMessage) {
      const text = translate('form.data.invalid')

      return (
        <FeedbackError
          className='margin-top-double'
          message={message.dsMessage}
          text={text}
        />
      )
    }
  }

  render() {
    const { translate, error, lmExpress, filters, auth } = this.props

    const { filtersVisible, lmExpressInfoVisible } = this.state

    return (
      <section>
        <ContentHeader>
          {translate('mobile.previousDayLmExpress')}
        </ContentHeader>

        <LmExpressHeader
          translate={translate}
          pageName={translate('mobile.previousDayLmExpress')}
        />

        {error && this.renderError(error.message)}

        {filtersVisible && (
          <BranchFilterLmExpress
            translate={translate}
            fetchLmExpress={this.handleFetchLmExpress}
            auth={auth}
          />
        )}

        {lmExpressInfoVisible && (
          <LmExpress
            translate={translate}
            lmExpress={lmExpress}
            getCsv={this.getCsv}
            filters={filters}
          />
        )}
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
/* istanbul ignore next */
const mapStateToProps = ({ lmExpressReducer, reportReducer }) => ({
  lmExpress: lmExpressReducer.record,
  error: lmExpressReducer.error,
  filters: lmExpressReducer.filters,
  report: reportReducer.get.record,
})

/*
 * Maps actions and dispatch them to component props
 */
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  /* istanbul ignore netx */
  bindActionCreators({ ...lmExpressActions, ...reportActions }, dispatch)

/*
 * Connects component to I18next
 */
/* istanbul ignore next */
const LmExpressTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(PreviousDayLmExpressContainer)

/*
 * Exports component connected to redux as default
 */
/* istanbul ignore next */
export default connect(mapStateToProps, mapDispatchToProps)(LmExpressTranslated)

export { PreviousDayLmExpressContainer }
